import React, { CSSProperties, ReactNode, useState } from 'react';
import Sidebar from '../components/main/Sidebar/Sidebar';
import { useCurrentUser } from '../App.hooks';
import AppRouting from '../App.routing';
import { Search, Bell } from 'lucide-react';

type AppShellProps = {
    style?: CSSProperties;
    children?: ReactNode;
};

const AppShell = (props: AppShellProps) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="flex h-full w-full" style={{ backgroundColor: 'var(--bg-app)' }}>
            <Sidebar
                collapsed={sidebarCollapsed}
                onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
            />
            <main className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                <AppRouting />
            </main>
        </div>
    );
};

export default AppShell;
